var map = {
	"./javascript/callback.snippet": [
		857,
		[
			857
		]
	],
	"./javascript/cookie.snippet": [
		954,
		[
			954
		]
	],
	"./javascript/url.snippet": [
		1,
		[
			1
		]
	],
	"./javascript/websocket.snippet": [
		7,
		[
			7
		]
	],
	"./node/callback.snippet": [
		498,
		[
			498
		]
	],
	"./node/cookie.snippet": [
		293,
		[
			293
		]
	],
	"./node/url.snippet": [
		744,
		[
			744
		]
	],
	"./node/websocket.snippet": [
		994,
		[
			994
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 585;
module.exports = webpackAsyncContext;